import { REHYDRATE } from 'redux-persist/constants';

import roadmapEndpoint from '../commons/rest/roadmapRest';
import restService from '../commons/rest/restService';
import RoadmapEntity from '../../../shared/src/entity/RoadmapEntity';
import attachments from '../attachments/attachments';
import { closeModal, openModal } from '../commons/components/modal/modalDucks';

/**
 * ====================================
 * The actions
 * ====================================
 */
const GET_ROADMAP_START = 'GET_ROADMAP_START';
const GET_ROADMAP_SUCCESS = 'GET_ROADMAP_SUCCESS';
const GET_ROADMAP_FAILURE = 'GET_ROADMAP_FAILURE';

const GET_ROADMAP_ATTACHMENT_START = 'GET_ROADMAP_ATTACHMENT_START';
const GET_ROADMAP_ATTACHMENT_PERSIST = 'GET_ROADMAP_ATTACHMENT_PERSIST';
const GET_ROADMAP_ATTACHMENT_SUCCESS = 'GET_ROADMAP_ATTACHMENT_SUCCESS';
const GET_ROADMAP_ATTACHMENT_FAILURE = 'GET_ROADMAP_ATTACHMENT_FAILURE';


/**
 * ====================================
 * The actions creators
 * ====================================
 */

const downloadRoadmapAttachment = roadmap => (dispatch) => {
  if (!roadmap || (!roadmap.loading && !roadmap.updating)) {
    return Promise.resolve();
  }

  dispatch({ type: GET_ROADMAP_ATTACHMENT_START });

  if (!roadmap.fileName) {
    return attachments.deleteAttachments([RoadmapEntity.ID])
      .then(() => {
        dispatch({ type: GET_ROADMAP_ATTACHMENT_SUCCESS });
      });
  }

  return restService.get(roadmap.attachmentUrl)
    .then((response) => {
      if (response.ok) {
        return response.arrayBuffer()
          .then(arrayBuffer => ({
            arrayBuffer,
            contentType: response.headers.get('Content-Type'),
          }));
      }
      return Promise.reject();
    })
    .then(({ arrayBuffer, contentType }) => {
      dispatch({ type: GET_ROADMAP_ATTACHMENT_PERSIST });
      return attachments.saveAttachment(RoadmapEntity.ID, arrayBuffer, contentType);
    })
    .then(() => {
      dispatch({ type: GET_ROADMAP_ATTACHMENT_SUCCESS });
      return Promise.resolve();
    })
    .catch((error) => {
      dispatch({ type: GET_ROADMAP_ATTACHMENT_FAILURE });
      /*
       * Managing Safari iOS out of memory
       */
      if (error && error.message &&
        (error.message.indexOf('An unknown error occurred within Indexed Database') >= 0
          || error.message.indexOf('An internal error was encountered in the Indexed Database server') >= 0)) {
        dispatch(openModal(
          'Une erreur fatale est survenue. Veuillez relancer le navigateur.',
          'Fermer',
          () => dispatch(closeModal())
        ));
      }
      return Promise.reject(error);
    });
};

export const loadRoadmap = () => (dispatch, getState) => {
  dispatch({ type: GET_ROADMAP_START });

  return roadmapEndpoint.get()
    .then((response) => {
      dispatch({ type: GET_ROADMAP_SUCCESS, payload: response.body(false) });
      return dispatch(downloadRoadmapAttachment(getState().roadmap.data));
    })
    .catch(err => dispatch({ type: GET_ROADMAP_FAILURE, payload: err }));
};


/**
 * ====================================
 * The reducer
 * ====================================
 */
const initialState = {
  data: null,
  error: false,
  loading: false,
};

const roadmapToState = (roadmap, oldRoadmap) => {
  const newRoadmap = new RoadmapEntity(roadmap);

  if (!oldRoadmap || !oldRoadmap.audit || !oldRoadmap.audit.updateDateTime || oldRoadmap.loading) {
    newRoadmap.loading = true;
  } else if (oldRoadmap.updating) {
    newRoadmap.updating = true;
    newRoadmap.oldFileName = oldRoadmap.oldFileName;
  } else if (newRoadmap.audit.updateDateTime > oldRoadmap.audit.updateDateTime) {
    newRoadmap.updating = true;
    newRoadmap.oldFileName = oldRoadmap.fileName;
  }

  return newRoadmap;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ROADMAP_START:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_ROADMAP_FAILURE:
      return {
        ...state,
        error: true,
        data: null,
        loading: false,
      };
    case GET_ROADMAP_SUCCESS:
      return {
        ...state,
        data: roadmapToState(action.payload, state.data),
        error: false,
        loading: false,
      };
    case GET_ROADMAP_ATTACHMENT_SUCCESS: {
      // eslint-disable-next-line no-unused-vars
      const { loading, updating, oldFilename, ...roadmap } = state.data;
      return {
        ...state,
        data: new RoadmapEntity(roadmap),
      };
    }
    case REHYDRATE:
      if (action.payload.roadmap && action.payload.roadmap.data) {
        return {
          ...state,
          data: new RoadmapEntity(action.payload.roadmap.data),
        };
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./book/src/roadmap/roadmapDucks.js